// https://vuex.vuejs.org/en/getters.html

export default {
  getUser: state => {
    return state
  }
}
